// Generated from products/analytics/shared/collectionConfig.ts; run analytics generate:site-runtime.
import { z } from "zod";
import { VisitorIdSchema } from "./contracts.gen";
export const collectionPath = "/_s/7c2f";
export const collectionStorageKey = "__s0";
export const collectionStorageLock = "__s0.init";
export const CollectionStorageSchema = z.strictObject({ visitorId: VisitorIdSchema });
export type CollectionStorage = z.infer<typeof CollectionStorageSchema>;
